import React = require('react');
import { get, head } from 'lodash';
import { useState } from 'react';
import { format } from 'date-fns';

interface IMTATravellerDetailProps {
  travellers: any[];
  noPadding?: boolean
}

const DATE_FORMAT = 'dd/MM/yyyy';

export const MTATravellerDetails = ({ travellers, noPadding }: IMTATravellerDetailProps) => {

  const [showDetails, setShowDetails] = useState(false);

  const handleOnClick = () => {
    setShowDetails(!showDetails)
  }

  const leadTraveller = head(travellers);
  const leadTravellerConditions = get(leadTraveller, 'screening.meta.conditions');
  const noMedicalConditionText = 'No Medical Conditions'
  const leadName = leadTraveller?.title + ' ' + leadTraveller?.first_name + ' ' + leadTraveller?.last_name;
  const leadDOB = format(new Date(leadTraveller?.dob), DATE_FORMAT)

  return (
    <div className={'details-overview'}>
      <div className={noPadding ? 'details-overview-header no_padding' : 'details-overview-header'} style={{ cursor: 'pointer' }} onClick={handleOnClick}>
        <div className={'d-overview-icon'}>
          <img src={require('../../../../../../Images/user.svg')} width={'45px'} alt={''}/>
        </div>
        <div className={'d-overview-text'}>Travellers</div>
        <div className={'d-overview-dropdown-icon'}>
          <img src={require('../../../../../../Images/arrow-down-sign-to-navigate.svg')} width={'45px'} alt={''}/>
        </div>
      </div>

      {showDetails && (
        <>
          <div className={'details-overview-row'}>
            <div className={'d-o-attribute'}>
              <div>{leadName}</div>
              <div className={'d-o-attribute-value'}>{leadDOB}</div>
              <div
                className={'d-o-attribute-value'}>{leadTravellerConditions ? leadTravellerConditions.join(', ') : noMedicalConditionText}</div>
            </div>
          </div>

          {travellers.length > 1 &&
            travellers.slice(1).map((traveller, index) => {
              const travellerConditions = get(traveller, 'screening.meta.conditions');
              const travellerName = traveller.title + ' ' + traveller.first_name + ' ' + traveller.last_name;
              return (
                <div className={'details-overview-row'} key={index}>
                  <div className={'d-o-attribute'}>
                    <div>{travellerName}</div>
                    <div className={'d-o-attribute-value'}>{format(new Date(traveller.dob), DATE_FORMAT)}</div>
                    <div
                      className={'d-o-attribute-value'}>{travellerConditions ? travellerConditions.join(', ') : noMedicalConditionText}</div>
                  </div>
                </div>
              )
            })
          }
        </>
      )}

    </div>
  )
}
